import type { FieldEdge, Field } from './FieldEdge.types.tsx';

export const transformData = (data: FieldEdge[]): Field[] => data.map((edge) => edge.node);
